import { makeRequest } from '../../../lib/api';

class vehiclesController {
  getCarmenMakes = () => {
    return makeRequest('get', '/v1/vehicle_make_carmen');
  };

  updateCarmenMake = (id, data) => {
    return makeRequest('put', `/v1/vehicle_make_carmen/${ id }`, data);
  };

  getCarmenUsers = () => {
    return makeRequest('get', '/v1/carmen/users');
  };

  updateCarmenUser = data => {
    const { id, ...rest } = data;
    return makeRequest('put', `/v1/carmen/users/${ id }`, rest);
  };
}

export default new vehiclesController();
